export class OEE {
  Type?: string = 'OEE';
  availability: number;
  bestCadence: number;
  cadence: number;
  count: number;
  counter1: number;
  counter2: number;
  cycleInfo: CycleInfo;
  downtime: number;
  last24Hours: Array<Last24Hours>;
  lastHour: number;
  lastMinute: number;
  minutesElapsed: number;
  ngcount: number;
  OEE: number;
  OEELast7Days: Array<Stats>;
  OEELast8Hours: Array<Stats>;
  operatingTime: number;
  performance: number;
  quality: number;
  reference: string;
  cmd: string;
  events: Array<Event>;
  pendingDowntimes: Array<Event>;
  sn: string;
}

export class Event {
  start: number;
  end: number;
  eventMode: number;
  eventType: number;
  eventSubMode: number;
  id: number;
  name?: string;
  justifyCode?: string;
  justifyDescription?: string;
}

export class Stop {
  [key: string]: stopType;
}
class stopType {
  values: Array<number[]>;
}

export class pendingStop {
  id: string;
  start: number;
  end: number;
}

export class CycleInfo {
  ActualCycleTime: number;
  CalculatedCycleTime: number;
  Count: number;
  QualityLevel: number;
  ReferenceCode: string;
  ResultsCount: number;
}

export class Last24Hours {
  AvgCadende: number;
  AvgCycleTime: number;
  Count: number;
  MaxCadence: number;
  MinCadence: number;
  Unit: number;
}

class Stats {
  Availability: number;
  AvgCycleTime: number;
  Count: number;
  Downtime: number;
  MinutesElapsed: number;
  OEE: number;
  OperatingTime: number;
  PartsDefective: number;
  Performance: number;
  Quality: number;
  Unit: number;
}
